/**
 * Toggle used by loadInterceptor and mediaStatusInterceptor for enabling a patch while
 * an issue related to liveSeekableRange is being resolved in the mobile apps.
 */
class LiveSeekableRangePatch {
    private _isEnabled: boolean = false;

    public get isEnabled(): boolean {
        return this._isEnabled;
    }

    public set isEnabled(value: boolean) {
        if (value !== this._isEnabled) {
            // eslint-disable-next-line no-console
            console.log(`${value ? 'Enabling' : 'Disabling'} live seekable range patch...`);
            this._isEnabled = value;
        }
    }
}

export const liveSeekableRangePatch = new LiveSeekableRangePatch();
